import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPalette } from './ColorPalette';
import FAQ from './FAQ';
import SupportRequest from './SupportRequest';

// Import the same backdrop image
import backdropImage1 from './images/BackdropNight.png';

function Help() {
  const navigate = useNavigate();
  const colors = getPalette('dark'); // You can change this to 'light' or 'auto' as needed
  
  // State for tab switching
  const [activeTab, setActiveTab] = useState('faq');

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backdropImage1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: colors.background,
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 10px'
      }}
    >
      {/* Central container with same styling as Platform_v2 */}
      <div
        style={{
          width: '100%',
          maxWidth: '650px',
          backgroundColor: colors.container,
          borderRadius: '12px',
          boxShadow: `0 4px 12px ${colors.shadow}`,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 40px)'
        }}
      >
        {/* Header with back button and title */}
        <div
          style={{
            padding: '20px 24px',
            borderBottom: `1px solid ${colors.outline}`,
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            flexShrink: 0,
            backgroundColor: colors.surface
          }}
        >
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: `2px solid ${colors.outline}`,
              fontSize: '20px',
              cursor: 'pointer',
              color: colors.text,
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = colors.primaryContainer;
              e.target.style.borderColor = colors.primary;
              e.target.style.color = colors.onPrimaryContainer;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = colors.outline;
              e.target.style.color = colors.text;
            }}
          >
            ←
          </button>
          <h1
            style={{
              margin: 0,
              fontSize: '24px',
              color: colors.text,
              fontWeight: '700'
            }}
          >
            Help & Support
          </h1>
        </div>

        {/* Tab Navigation */}
        <div
          style={{
            display: 'flex',
            backgroundColor: colors.surfaceVariant,
            margin: '0',
            flexShrink: 0
          }}
        >
          <button
            onClick={() => setActiveTab('faq')}
            style={{
              flex: 1,
              padding: '18px 24px',
              backgroundColor: activeTab === 'faq' ? colors.primary : 'transparent',
              color: activeTab === 'faq' ? colors.onPrimary : colors.text,
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'faq' ? '600' : '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative'
            }}
            onMouseEnter={(e) => {
              if (activeTab !== 'faq') {
                e.target.style.backgroundColor = colors.primaryContainer;
                e.target.style.color = colors.onPrimaryContainer;
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'faq') {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = colors.text;
              }
            }}
          >
            FAQ
            {activeTab === 'faq' && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '40px',
                  height: '3px',
                  backgroundColor: colors.onPrimary,
                  borderRadius: '2px 2px 0 0'
                }}
              />
            )}
          </button>
          <button
            onClick={() => setActiveTab('support')}
            style={{
              flex: 1,
              padding: '18px 24px',
              backgroundColor: activeTab === 'support' ? colors.primary : 'transparent',
              color: activeTab === 'support' ? colors.onPrimary : colors.text,
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'support' ? '600' : '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative'
            }}
            onMouseEnter={(e) => {
              if (activeTab !== 'support') {
                e.target.style.backgroundColor = colors.primaryContainer;
                e.target.style.color = colors.onPrimaryContainer;
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'support') {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = colors.text;
              }
            }}
          >
            Support
            {activeTab === 'support' && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '40px',
                  height: '3px',
                  backgroundColor: colors.onPrimary,
                  borderRadius: '2px 2px 0 0'
                }}
              />
            )}
          </button>
        </div>

        {/* Content Area */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto'
          }}
        >
          {activeTab === 'faq' ? <FAQ /> : <SupportRequest />}
        </div>
      </div>
    </div>
  );
}

export default Help;